import {BuyerCard} from './BuyerCard';

import type {BuyerTableRow} from '../types/buyers.types';
import type {BuyerDTO, BuyerPurchaseDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface BuyerCardListProps {
  rows: BuyerTableRow[];
  onRequestPayment: (buyer: BuyerDTO, purchase: BuyerPurchaseDTO) => void;
  onViewBuyer: (buyer: BuyerDTO, purchase: BuyerPurchaseDTO) => void;
  onEditBuyer: (buyers: BuyerDTO[]) => void;
  onDeleteBuyer: (buyer: BuyerDTO, purchase: BuyerPurchaseDTO) => void;
  trustAccountId: string;
}

export const BuyerCardList: FC<BuyerCardListProps> = ({
  rows,
  onRequestPayment,
  onViewBuyer,
  onEditBuyer,
  onDeleteBuyer,
  trustAccountId
}) => {
  return (
    <div className="grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      {rows.map(row => (
        <BuyerCard
          key={row.purchase.id}
          row={row}
          onRequestPayment={onRequestPayment}
          onViewBuyer={onViewBuyer}
          onEditBuyer={onEditBuyer}
          onDeleteBuyer={onDeleteBuyer}
          trustAccountId={trustAccountId}
        />
      ))}
    </div>
  );
};
